import { translator } from "../../../translation/translator";
import { SearchUserModalSetup } from "../../../search/user/modal/search-user-modal-setup";
import { ChipPickerHandler } from "../chips/chip-picker-handler";
import { ChipPickerListener } from "../chips/chip-picker-listener";
import { SearchUserPickerForm } from "./search-user-picker-form";

export interface SearchUserPickerSetupParams {
    menuRoot: HTMLElement;
    initialSelectedIds: string[];
    onSelectionChange: (ids: string[]) => void;
}

export class SearchUserPickerSetup {
    public static setupForSearchMenu(params: SearchUserPickerSetupParams): ChipPickerHandler | null {
        const { menuRoot, initialSelectedIds, onSelectionChange } = params;

        const pickerRoot = SearchUserPickerForm.getPickerRoot(menuRoot);
        const chipsEl = SearchUserPickerForm.getChips(menuRoot);

        if (!(pickerRoot instanceof HTMLElement) || !(chipsEl instanceof HTMLElement)) {
            return null;
        }

        const modal = SearchUserModalSetup.init(document);
        if (!modal) return null;

        const instanceKey = (() => {
            const existing = String(pickerRoot.dataset.pickerInstanceKey || "").trim();
            if (existing) return existing;
            const created = `search-user-picker-${Date.now()}-${Math.random().toString(16).slice(2)}`;
            pickerRoot.dataset.pickerInstanceKey = created;
            return created;
        })();

        const controller = new ChipPickerHandler({
            chipsEl,
            openBtnEl: pickerRoot,
            idAttribute: "data-user-id",
            removeAction: "remove",
            renderOptions: {
                chipClass: "picker-chip",
                labelClass: "picker-chip__label",
                labelIsHtml: true,
                removeClass: "picker-chip__remove",
                removeAriaLabel: "Remove",
                hideUnknownLabels: true,
                emptyHtml:
                    '<span class="input-placeholder search-item" data-translate="select_user">Select user</span>',
            },
        });

        modal.setSelectedIds(initialSelectedIds);

        controller.setLabelMap(modal.getLabelMap());
        controller.setSelectedIds(initialSelectedIds);
        controller.setOnSelectionChange(onSelectionChange);
        controller.setExternalSelectionUI({
            setSelectedIds: (ids: string[]) => modal.setSelectedIds(ids),
            setOnSelectionChange: (callback: (ids: string[]) => void) =>
                modal.setOnSelectionChange(
                    (ids) => {
                        controller.mergeLabelMap?.(modal.getLabelMap());
                        callback(ids);
                    },
                    { key: instanceKey },
                ),
            open: () => modal.open(),
        });

        controller.render();
        translator.updateUITranslations();

        ChipPickerListener.setup({
            rootEl: pickerRoot,
            scopeKey: "search-user-picker",
            openBtnEl: pickerRoot,
            chipsEl,
            controller,
        });

        return controller;
    }
}
